import React, { useContext } from 'react';

import { Select } from 'antd';

import { ListContext } from '@contexts/ListContext';

const Option = Select.Option;

const TaxSelector = ({ onChange, value, disabled, onBlur }) => {
    const { cachedList } = useContext(ListContext);
    const taxOptions = cachedList.taxmethods.items.Taxes.filter((el) => !el.Disabled);

    return (
        <Select
            autoComplete="off"
            mode="single"
            value={value || undefined}
            placeholder="Select tax code"
            onChange={onChange}
            onBlur={onBlur}
            disabled={disabled}
            allowClear
            getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
            {taxOptions.map((el) => (
                <Option key={el.Code} value={el.Code}>
                    {el.Name}
                </Option>
            ))}
        </Select>
    );
};

export default TaxSelector;
